import ClientType from '@/models/ClientType';
import ClientTypeRepository from '@/repositories/ClientTypeRepository';

/**
 * Valid architect client type codes (case-insensitive)
 */
const ARCHITECT_CODES = ['ARHITEKT', 'ARCHITEKT'];

/**
 * Checks if a client type is an architect type
 * @param clientType The client type to check
 * @returns true if the client type is architect
 */
export function isArchitectClientType(clientType: ClientType): boolean {
    if (!clientType?.code) {
        return false;
    }
    return ARCHITECT_CODES.includes(clientType.code.toUpperCase());
}

/**
 * Finds the architect client type from the repository
 * @returns The architect ClientType or undefined if not found
 */
export function getArchitectClientType(): ClientType | undefined {
    const clientTypes = ClientTypeRepository.getByType('TYPE');
    return clientTypes.find(isArchitectClientType);
}

/**
 * Generates the architect filter query string for API requests
 * @returns The filter query string (e.g., 'clientTypes=3')
 */
export function getArchitectFilterQuery(): string {
    const architectType = getArchitectClientType();
    return architectType ? `clientTypes=${architectType.id}` : 'clientTypes=3';
}
